export default __webpack_public_path__ + "static/_/_/legos/assets/valorant/ranks/episode-1/ep-1-22-immortal-2-large.webp";